import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import classnames from 'classnames';
import { Flex } from '@cognite/cogs-core';
import { useSlots, IconWrapper } from '@cognite/cogs-utils';
import { PageHeaderLink, PageHeaderNavigation, PageHeaderActions, PageHeaderTitleArea, PageHeaderBreadcrumbs } from './elements.js';

/**
 * Pageheader is a section that is used to display information about the current page including the page title, description, and navigation.
 */
var PageHeaderInternal = /*#__PURE__*/React.forwardRef(function (_a) {
  var className = _a.className,
    dataTestId = _a['data-testid'],
    children = _a.children,
    _a$padding = _a.padding,
    padding = _a$padding === undefined ? 'standard' : _a$padding,
    fullWidth = _a.fullWidth,
    icon = _a.icon,
    otherProps = __rest(_a, ["className", 'data-testid', "children", "padding", "fullWidth", "icon"]);
  var _useSlots = useSlots(children, {
      link: PageHeaderLink,
      actions: PageHeaderActions,
      navigation: PageHeaderNavigation,
      titlearea: PageHeaderTitleArea,
      breadcrumbs: PageHeaderBreadcrumbs
    }),
    _useSlots2 = _slicedToArray(_useSlots, 1),
    slots = _useSlots2[0];
  return jsx("div", Object.assign({
    "data-testid": dataTestId,
    className: classnames('cogs-lab', 'cogs-pageheader-container', "cogs-pageheader--".concat(padding), fullWidth && "cogs-pageheader--full-width", className)
  }, otherProps, {
    children: jsxs(Flex, {
      direction: "column",
      className: classnames('cogs-pageheader'),
      children: [jsxs("div", {
        className: "cogs-pageheader-content",
        children: [icon && jsx("div", {
          className: "cogs-pageheader__icon",
          children: jsx(IconWrapper, {
            size: 16,
            children: icon
          })
        }), slots.titlearea, slots.actions]
      }), slots.navigation && jsx(Flex, {
        className: "cogs-pageheader-tabs",
        children: slots.navigation
      })]
    })
  }));
});
var PageHeader = Object.assign(PageHeaderInternal, {
  /**
   * @deprecated This component will be removed in v11 as link functionality is
   * no longer supported.
   * TODO(CGS-1720)
   */
  Link: PageHeaderLink,
  Navigation: PageHeaderNavigation,
  Actions: PageHeaderActions,
  TitleArea: PageHeaderTitleArea,
  /**
   * @deprecated This component will be removed in v11 as breadcrumbs
   * functionality is no longer supported.
   * TODO(CGS-1720)
   */
  Breadcrumbs: PageHeaderBreadcrumbs
});

export { PageHeader };
